import React from 'react';

const ConfirmationModal = ({ isVisible, onConfirm, onCancel }) => {
  const handleModalClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div 
      className={`confirmation-modal ${isVisible ? 'show' : ''}`}
      onClick={handleModalClick}
    >
      <div className="confirmation-modal-content">
        <div className="confirmation-modal-title">Confirm Deletion</div>
        <div className="confirmation-modal-message">
          Are you sure you want to remove this bookmark? This action cannot be undone.
        </div>
        <div className="confirmation-modal-buttons">
          <button 
            className="confirmation-modal-btn confirm" 
            onClick={onConfirm}
          >
            Yes, Remove
          </button>
          <button 
            className="confirmation-modal-btn cancel" 
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;